import { getYear, isSameMonth, format } from 'date-fns';
import * as Locales from 'date-fns/locale';

var agodaLocaleToDateFnsLocale = {
  'en-us': Locales.enUS,
  'fr-fr': Locales.fr,
  'de-de': Locales.de,
  'it-it': Locales.it,
  'es-es': Locales.es,
  'ja-jp': Locales.ja,
  'zh-hk': Locales.zhHK,
  'zh-cn': Locales.zhCN,
  'ko-kr': Locales.ko,
  'el-gr': Locales.el,
  'ru-ru': Locales.ru,
  'pt-pt': Locales.pt,
  'nl-nl': Locales.nl,
  'en-ca': Locales.enCA,
  'en-in': Locales.enIN,
  'en-gb': Locales.enGB,
  'en-za': Locales.enZA,
  'en-au': Locales.enAU,
  'zh-tw': Locales.zhTW,
  'en-nz': Locales.enNZ,
  'th-th': Locales.th,
  'vi-vn': Locales.vi,
  'sv-se': Locales.sv,
  'id-id': Locales.id,
  'pl-pl': Locales.pl,
  'nb-no': Locales.nb,
  'da-dk': Locales.da,
  'fi-fi': Locales.fi,
  'cs-cz': Locales.cs,
  'tr-tr': Locales.tr,
  'ca-es': Locales.ca,
  'hu-hu': Locales.hu,
  'hi-in': Locales.hi,
  'bg-bg': Locales.bg,
  'ro-ro': Locales.ro,
  'sl-si': Locales.sl,
  'he-il': Locales.he,
  'ar-ae': Locales.ar,
  'nl-be': Locales.nlBE,
  'en-ie': Locales.enIE,
  'pt-br': Locales.ptBR,
  'lt-lt': Locales.lt,
  'lv-lv': Locales.lv,
  'hr-hr': Locales.hr,
  'et-ee': Locales.et,
  'uk-ua': Locales.uk,
  'en-sg': Locales.enGB,
  'ms-my': Locales.ms,
  'es-ar': Locales.es,
  'tl-ph': Locales.ta,
  'es-mx': Locales.es
};
var weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
var getDateFnsLocale = function getDateFnsLocale(locale) {
  return agodaLocaleToDateFnsLocale[locale];
};
var getStartingDayOfWeekNumber = function getStartingDayOfWeekNumber(locale) {
  var _locale$options$weekS, _locale$options;
  return (_locale$options$weekS = locale === null || locale === void 0 || (_locale$options = locale.options) === null || _locale$options === void 0 ? void 0 : _locale$options.weekStartsOn) !== null && _locale$options$weekS !== void 0 ? _locale$options$weekS : 0;
};
var getDateFnsLocaleOrDefault = function getDateFnsLocaleOrDefault(locale) {
  var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Locales.enUS;
  if (!locale) {
    return defaultLocale;
  }
  return getDateFnsLocale(locale);
};
var range = function range(start, end) {
  var length = end - start;
  return Array.from({
    length: length
  }, function (_, i) {
    return start + i;
  });
};
var generateYearRange = function generateYearRange(selectedDate) {
  var year = getYear(selectedDate);
  var start = year - year % 10 - 1;
  return Array.from({
    length: 12
  }).map(function (_, i) {
    return start + i;
  });
};
var isDifferentMonth = function isDifferentMonth(date1, date2) {
  return !date1 || !date2 ? true : !isSameMonth(date1, date2);
};
var formatMonth = function formatMonth(date, locale) {
  return format(date, 'LLLL', locale ? {
    locale: locale
  } : undefined);
};
var formatYear = function formatYear(date, locale) {
  return format(date, 'y', locale ? {
    locale: locale
  } : undefined);
};

export { formatMonth, formatYear, generateYearRange, getDateFnsLocale, getDateFnsLocaleOrDefault, getStartingDayOfWeekNumber, isDifferentMonth, range, weekDays };
//# sourceMappingURL=index.js.map
